import useSWR from "swr";
import { useRediaPlatformContext } from "../../../rediaPlatform/RediaPlatformProvider";
import { usePatronConfiguration } from "./usePatronConfiguration";
import { Locations } from "@libry-content/redia-platform";

export type PickupLocation = Locations["branches"][number];

export const useLocations = () => {
  const { rediaPlatform } = useRediaPlatformContext();
  const swrCacheKey = rediaPlatform ? "rediaPlatform:locations" : null;
  return useSWR(swrCacheKey, () => rediaPlatform?.getLocations());
};

export const usePickupLocations = () => {
  const { data: configuration } = usePatronConfiguration();
  const { data: locations } = useLocations();

  return (
    configuration?.reservation?.pickupLocations?.map((loc) => {
      const code = loc.branch.code;
      const name = locations?.branches?.find((branch) => branch.code === code)?.name ?? "";
      return {
        code,
        name,
      };
    }) ?? []
  );
};
